/*
THIS IS THE COMPONENT THAT WILL BE USED TO RENDER THE FOLLOWING COMPONENTS
- CHECKOUT STEPPER
- CUSTOMER INFORMATION SUCH AS NAME AND LOGGED IN STATUS
- DYNAMIC COMPONENT LIKE SHIPPING ADDRESS INFO / PAYMENT METHOD INFO / SUMMARY
- NAVIGATION BUTTONS TO MOVE TO THE NEXT STAGE OR BACK
*/
import React, { useEffect, useState, useRef } from 'react';
import './LeftPanel.css';

import CustomerInfoHeader from './CustomerInfoHeader/CustomerInfoHeader';
import CustomerSummary from './CustomerSummary/CustomerSummary';
import ShippingAddress from './ShippingAddress/ShippingAddress';
import ShippingMethod from './ShippingMethod/ShippingMethod';
// import BillingAddress from './BillingAddress/BillingAddress'; // Hidden: already shown in Payment modal
import Payment from './Payment/Payment';
import ThankYou from './ThankYou/ThankYou';
import Stepper from '../Stepper/Stepper';
//import SmallStepper from '../Stepper/SmallStepper';
import Buttons from '../Buttons/Buttons';
import { useSelector, useDispatch } from 'react-redux';
import { getAddressReport, getCustomerReport } from '../../helper/Utility';
import CartService from '../../services/CartService';
import { setConfirmSchedule, setLoading, setShippingAddress } from '../../actions/actionCreators';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTranslation } from 'react-i18next';
import { Paper, Button } from '@material-ui/core';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { APP_TYPE, ZENPAY, SCHEDULER } from '../../constants/AppConstants';
import CheckoutStepper from '../Stepper/Stepper';

const LeftPanel = (props) => {
  const source = props.source;
  const cart = useSelector(state => state.cartReducer);
  const navigation = useSelector(state => state.navigationReducer);
  const urlParams = useSelector(state => state.urlParamsReducer) || { token: 0 };
  const dispatch = useDispatch();
  const matches = useMediaQuery("(max-width:599px)");
  const frontConfig = useSelector(state => state.frontConfigReducer);
  const shippingSelection = useSelector(state => state.shippingMethodReducer.selection);
  const [shippingType, setShippingType] = useState("");
  const { t, i18n } = useTranslation();
  const addressDiv = useRef(null);

  useEffect(() => {
    if (navigation.checkoutStep === 1 && APP_TYPE === ZENPAY) {
      addressDiv.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [navigation.checkoutStep])


  useEffect(() => {
    if (APP_TYPE === ZENPAY) {
      checkAddressPostRequired();
      checkCustomerPostRequired();
    }
  }, [navigation.checkoutStep])

  useEffect(() => {
    setShippingType(shippingSelection.type);
  })

  return (
    <div className={APP_TYPE === ZENPAY ? "LeftPanel" : "LeftPanelScheduler"} style={source === 'shopify' ? { width: "100%", height: 'auto' } : null}>
      {/* {
        APP_TYPE === ZENPAY && navigation.checkoutStep < 3 && navigation.checkoutStep > 1 && cart.shipping_address && !matches ?
          <div className="CustomerShippingHeader">
            <p className="CustomerNameHeaderTitle">{`${t("Hello")} ${cart.customer.is_registered && cart.customer.first_name !== null ? cart.customer.first_name : cart.customer.is_registered ? cart.customer.email : 'Guest'},`}</p>
            <p className="CustomerShippingSubHeader">{t("Choose how you want to get your order")}</p>
          </div> : APP_TYPE === ZENPAY && navigation.checkoutStep === 1 && cart.shipping_address && !matches ?
            <div className="CustomerShippingHeader">
              <p className="CustomerNameHeaderTitle">{`${t("Hello")} ${cart.customer.is_registered && cart.customer.first_name !== null ? cart.customer.first_name : cart.customer.is_registered ? cart.customer.email : 'Guest'},`}</p>
              <p className="CustomerShippingSubHeader">{t("Please fill out the following information")}</p>
            </div> : null
      } */}
      {/* {
        APP_TYPE === ZENPAY && navigation.checkoutStep === 1 && cart.shipping_address && props.appConfigLoaded && matches ?
          <div className="CustomerShippingHeader">
            <p className="CustomerNameHeaderTitle">{`${t("Hello")} ${cart.customer.is_registered && cart.customer.first_name !== null ? cart.customer.first_name : cart.customer.is_registered ? cart.customer.email : 'Guest'},`}</p>
            <p className="CustomerShippingSubHeader">{t("Please fill out the following information")}</p>
          </div> : null
      } */}
      {
        APP_TYPE === ZENPAY && props.appConfigLoaded ?

          <CheckoutStepper />

          : null
      }
      {
        APP_TYPE === ZENPAY && navigation.checkoutStep === 1 && cart.shipping_address && props.appConfigLoaded ?
          <div style={{ width: '90%' }}>
            <h3 className="CustomerHeader">{t("Customer")}</h3>
            <Paper elevation={3} style={{ borderRadius: 6 }}>
              <CustomerInfoHeader />
            </Paper>
          </div>
          : null
      }
      {
        APP_TYPE === SCHEDULER && source !== "shopify" ?
          <div className="CustomerShippingHeader">
            <p className="CustomerNameHeaderTitle">{`${t("Hello there,")}`}</p>
            <p className="CustomerShippingSubHeader">{t("You can check what availabilities for delivery or pickup are available before you place your order")}</p>
          </div>
          : null
      }

      <div className="ContentContainer">
        <div className="PaddedContentContainer">
          {
            APP_TYPE === ZENPAY && navigation.checkoutStep === 1 ?
              customerShippingContent() : null
          }
          {
            APP_TYPE === ZENPAY && navigation.checkoutStep >= 2 && navigation.checkoutStep !== 4 ?
              shippingMethodContent() : null
          }
          {
            APP_TYPE === ZENPAY && navigation.checkoutStep === 3 ?
              paymentContent() : null
          }
          {
            APP_TYPE === ZENPAY && navigation.checkoutStep === 4 ?
              thankYouContent() : null
          }
          {
            APP_TYPE === SCHEDULER && navigation.confirmationSuccess === false && cart.shipping_address !== undefined ?
              <div className="ShippingInsideContainer" style={source === 'shopify' ? { paddingTop: 10 } : null}>
                <h3 className="ScheduleHeader" style={source === 'shopify' ? { display: 'none' } : null}>{t("Schedule")}</h3>
                <Paper elevation={3} style={{ borderRadius: 6, width: '90%', marginBottom: 10, boxShadow: 'none' }} >
                  <ShippingMethod source={source} />
                </Paper>
              </div>
              : null
          }
        </div>
      </div>
      {APP_TYPE === ZENPAY && navigation.checkoutStep != 4 ?
        <div className="NavigationBtnsContainer">
          <div className="PaddedNavBtnsContainer">
            <Buttons />
          </div>
        </div>
        : null
      }
      {APP_TYPE === SCHEDULER && urlParams.source !== 'pa' ?
        <div className="NavigationSchedulerBtnsContainer">
          <div className="PaddedNavSchedulerBtn">
            <Button onClick={confirmScheduleSelection} variant="contained" style={{ padding: "5px 20px" }}>
              <DateRangeIcon style={{ fill: frontConfig.color }} />
              <p className="ScheduleDeliveryTxt" style={{ color: frontConfig.color }}>{shippingType.includes("pickup") ? t("Schedule Pickup") : t("Schedule Delivery")}</p>
            </Button>
          </div>
        </div>
        : null
      }
    </div>
  )

  function confirmScheduleSelection() {
    dispatch(setConfirmSchedule(true));
  };

  function customerShippingContent() {
    return (
      <div className="CustomerInfoDiv" ref={addressDiv}>
        <h3 className="ShippingAddressHeader">{t("Shipping Address")}</h3>
        {
          cart.shipping_address !== undefined && !navigation.loading ?
            <Paper elevation={3} style={{ borderRadius: 6, width: '90%', marginBottom: '1rem' }}><ShippingAddress /></Paper> : null
        }
      </div>
    )
  }

  function shippingMethodContent() {
    return (
      <div className="ShippingInsideContainer" style={navigation.checkoutStep === 3 ? { display: 'none' } : { width: '100%' }}>
        <h3 className="ScheduleHeader">{t("Schedule")}</h3>
        <Paper elevation={3} style={{ borderRadius: 6, width: '90%', marginBottom: '3rem' }} >
          <CustomerSummary />
        </Paper>

        <Paper elevation={3} style={{ borderRadius: 6, width: '90%', marginBottom: '1rem' }} >
          <ShippingMethod />
        </Paper>
      </div>
    )
  }
  function paymentContent() {
    return (
      <div className="AbsolutePaymentDiv">
        <h3 className="PaymentTitle">{t("Payment method")}</h3>
        <Paper elevation={3} style={{ borderRadius: 6, width: '90%', padding: '1rem', boxSizing: 'border-box', marginBottom: '1rem' }}>
          <Payment />
        </Paper>
        {/* Hidden: BillingAddress already shown in the Payment modal popup
        <h3 className="BillingTitle">{t("Billing Address")}</h3>
        <Paper elevation={3} style={{ borderRadius: 6, width: '90%', padding: '1rem', boxSizing: 'border-box', marginBottom: '1rem' }}>
          <BillingAddress />
        </Paper>
        */}
      </div >
    )
  }

  function thankYouContent() {
    return (
      <ThankYou />
    )
  }

  async function checkAddressPostRequired() {
    if (navigation.checkoutStep === 2) {
      dispatch(setLoading(true));
      const addressReport = getAddressReport(cart);
      const updateResponse = await CartService.updateShippingAddress(addressReport, cart.token);
      if (updateResponse.address1) {
        dispatch(setShippingAddress(updateResponse))
      }
      dispatch(setLoading(false));
    }
  }

  async function checkCustomerPostRequired() {
    if (navigation.checkoutStep === 2) {
      dispatch(setLoading(true));
      const customerReport = getCustomerReport(cart.customer);
      const updateResponse = await CartService.updateCustomer(customerReport, cart.token);
      dispatch(setLoading(false));
    }
  }
}

export default LeftPanel;
